import React, {Fragment} from "react";
import FigureEditor from "../editors/figureEditor";
import FigureActionGallery from "../editors/lists/figureActionGallery";
import {ChildFragmentEditor} from "../editors/FragmentEditor";
import ModalEditor from "../editors/ModalEditor";

export default class Figures extends React.Component {

    getId = () => {
        return this.props.componentId !== undefined ? this.props.componentId : (this.props.componentConfig.fielddefs[this.props.name] || {}).boundfield ? (this.props.data || {})[(this.props.componentConfig.fielddefs[this.props.name] || {}).boundfield] : (this.props.data || {})[this.props.componentConfig.idfield]
    }

    getComponent = () => {
        return this.props.component !== undefined ? this.props.component : this.props.componentConfig.componentname;
    }

    isVisible = () => {
        return this.props.component !== undefined ? this.props.componentId !== undefined : ((this.props.componentConfig.fielddefs[this.props.name] || {}).boundfield ? (this.props.data || {})[(this.props.componentConfig.fielddefs[this.props.name] || {}).boundfield] : (this.props.data || {})[this.props.componentConfig.idfield]);
    }

    render() {
        let style = {};
        if (this.props.label === false) {
            style.display = "none";
        }
        return <Fragment>
            <label className="control-label" style={style}>{this.props.label} {this.props.required && <span className="invalid-feedback">*</span>}</label>
            {
                this.isVisible() ?
                <FigureEditor
                    editorContext={this.getComponent() + "_" + this.props.name}
                    component={this.getComponent()}
                    componentId={this.getId()}
                    listType={FigureActionGallery}
                    list={ChildFragmentEditor}
                    editor={ModalEditor}
                    selection={null}
                /> : <Fragment>Kérlek mentsd el a kép(ek) feltöltés előtt!</Fragment>
            }
        </Fragment>
    }
}